import React from 'react'
import PropTypes from 'prop-types'
import {
    Row,
    Col,
    FormGroup,
    Label
} from 'reactstrap'
import DateInput from './DateInput'

import './ExportIncidentsFilter.scss'

class ExportIncidentsFilterButton extends React.Component {

    static propTypes = {
        start: PropTypes.oneOfType([ PropTypes.number, PropTypes.string ]),
        end: PropTypes.oneOfType([ PropTypes.number, PropTypes.string ]),
        onSelectionChanged: PropTypes.func
    }

    static defaultProps = {
        start: null,
        end: null,
        onSelectionChanged: () => {}
    }

    handleStartDateInputChange = start => {
        this.props.onSelectionChanged({
            start,
            end: this.props.end
        })
    }

    handleEndDateInputChange = end => {
        this.props.onSelectionChanged({
            start: this.props.start,
            end
        })
    }

    render() {
        return (
            <Row className="ao-export-filter">
                <Col md={ 6 }>
                    <FormGroup>
                        <Label for="start">Vanaf</Label>
                        <DateInput
                            date={ this.props.start }
                            onDateChange={ this.handleStartDateInputChange }
                        />
                    </FormGroup>
                </Col>
                <Col md={ 6 }>
                    <FormGroup>
                        <Label for="end">Tot en met</Label>
                        <DateInput
                            date={ this.props.end }
                            onDateChange={ this.handleEndDateInputChange }
                        />
                    </FormGroup>
                </Col>
            </Row>
        )
    }
}

export default ExportIncidentsFilterButton
